import { ConversionType } from "@gtpl/shared-models/common-models";
import { ProductConversionModel } from "@gtpl/shared-models/procurement-management";
import { Stock } from "../stock.entity";

export class ProductConversionAdapter {
    convertDtoToEntity(dtoObj: ProductConversionModel): Stock {
        try {
            console.log(dtoObj)
            // const stockItems : Stock[] = []
            const entityObj = new Stock();
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.unitId = dtoObj.unitId;
            entityObj.physicalQuantity = dtoObj.conversionQuantity
            entityObj.itemCategoryId = 6;
            entityObj.itemSubCategoryId = dtoObj.itemSubCategoryId;
            let updatedSoId
            if(dtoObj.conversionType == ConversionType.saleorder_to_bulk){
                updatedSoId = 0
            }
            if(dtoObj.conversionType == ConversionType.saleorder_to_saleorder){
                updatedSoId = dtoObj.toSaleOrderId;
            }
            entityObj.saleOrderId = updatedSoId;
            entityObj.itemId = dtoObj.toSaleOrderItemId;
            entityObj.sizeId = 0;
            entityObj.unitPrice = 0;
            entityObj.updatedUser = dtoObj.createdUser;
            entityObj.locationId = dtoObj.locationId;
            entityObj.preparedQuantity = 0
            entityObj.intransitQuantity = 0
            entityObj.reservedQuantity = 0
            // entityObj.minimumStock = 10000;
            return entityObj;

        } catch (Error) {
            return Error;
        }
    }
}
